import React, { useContext, useEffect, useState } from "react";
import {
  Paper,
  makeStyles,
  Box,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Button,
  Tooltip,
  TextField,
  InputAdornment,
  useTheme,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import SearchIcon from "@material-ui/icons/Search";
import AddIcon from "@material-ui/icons/Add";
import { useDispatch, useSelector } from "react-redux";
import { getStaff, activeOrDeactiveStaff } from "../../store/action";
import history from "../../utils/HistoryUtils";
import EnhancedTableHead from "./EnhancedTableHead";
import { headCells } from "./Headcells";
import AlertDialog from "../../components/Alert/AlertDialog";
import Loading from "../../components/Loading/Loading";
import { Visibility } from "@material-ui/icons";
import ToggleOnIcon from '@material-ui/icons/ToggleOn';
import ToggleOffIcon from '@material-ui/icons/ToggleOff';
import TablePaginationControls from "../../components/TablePaginationControls";
import { Link as RouterLink } from 'react-router-dom';
import MuiLink from '@mui/material/Link';
import { ThemeContext } from "../../App";
// const useStyle = makeStyles((theme) => ({
//   root: {
//     width: "100%",
//     // overflowX: "auto",
//     padding: 24,
//   },

const useStyle = makeStyles((theme) => ({
  root: {
    width: "100%",
    // overflowX: "auto",
    padding: 20,
    background: theme.palette.background.main
  },
  container: {
    maxHeight: "calc(100vh - 260px)",
  },
  viewBtn: {
    display: "flex",
    alignItems: "center",
    width: "max-content",
    cursor: "pointer",
    // color: theme.palette.secondary.main,
    gap: 4,
  },
  formControl: {
    width: "24%",
    marginTop: "10px",
  },
  searchIcondet: {
    marginRight: "14px",
  },
}));


const ViewStaff = ({ match }) => {
  const { mode } = useContext(ThemeContext);
  const theme = useTheme();
  const classes = useStyle();
  const dispatch = useDispatch();
  const [page, setPage] = React.useState(1);
  const [perPage, setPerPage] = useState(15);
  const { loading, getStaffItem } = useSelector((state) => state.staff);
  const [searchData, setSearchData] = useState({ search: "" });
  let staffDetail = JSON.parse(localStorage.getItem("staffDetail"));
  staffDetail = staffDetail ? staffDetail.replace(/['"]+/g, "") : null;
  const loggedRole = localStorage.getItem("role").replace(/['"]+/g, "");
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("users.first_name");
  const [staffId, setStaffId] = React.useState(0);
  const [activeOpen, setActiveOpen] = useState(false);
  const [deActiveOpen, setDeActiveOpen] = useState(false);
  const [staffNotify, setStaffNotify] = useState(false);
  const loginUserInfo = JSON.parse(localStorage.getItem("loginUserInfo"));

  const onhandlClick = (id) => {
    history.push(`${match.url}/${id}/detail`);
  };

  const handleChangePage = (event, value) => {
    setPage(value);
    setTimeout(getStaff1(value, perPage), 2000);
  };

  const handlePerPageChange = (event) => {
    const newPerPage = event.target.value;
    setPerPage(newPerPage);
    setPage(page); // Reset to first page when changing items per page
    getStaff1(page, newPerPage, searchData.search);
  };

  const getStaff1 = (
    pageNo = 1,
    perPage = 15,
    search = "",
    type = order,
    column_name = orderBy
  ) => {
    dispatch(getStaff({ pageNo, perPage, search, type, column_name }));
  };

  const handleSearchChange = (event) => {
    const searchValue = event.target.value;
    setSearchData({ ...searchData, [event.target.name]: searchValue });
    const timeoutId = setTimeout(() => {
      if (searchValue) {
        getStaff1(1, perPage, searchValue);
      } else {
        getStaff1(page, perPage, "");
      }
    }, 100);

    return () => clearTimeout(timeoutId);
  };

  const handleClickSearch = (event, value) => {
    setTimeout(getStaff1(1, perPage, searchData.search), 1000);
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const aActiveClose = () => {
    setActiveOpen(false);
  };

  const dActiveClose = () => {
    setDeActiveOpen(false);
  };

  const alertActiveResponse = async (id) => {
    await dispatch(activeOrDeactiveStaff(id, 1));
    getStaff1(page, perPage, searchData.search);
    setStaffNotify(true);
  };

  const alertDeActiveResponse = async (id) => {
    await dispatch(activeOrDeactiveStaff(id, 0));
    getStaff1(page, perPage, searchData.search);
    setStaffNotify(true);
  };

  const onHandlActive = (id) => {
    setActiveOpen(true);
    setStaffId(id);
  };

  const onHandlDeActive = (id) => {
    setDeActiveOpen(true);
    setStaffId(id);
  };

  useEffect(() => {
    getStaff1(page, perPage, searchData.search);
  }, [orderBy, order, perPage]);

  useEffect(() => {
    document.documentElement.style.setProperty('--bg-color', theme.palette.grey[1000]);
    document.documentElement.style.setProperty('--sticky-header', theme.palette.thead);
    document.documentElement.style.setProperty('--sticky-odd', theme.palette.background.stickyOdd);
    document.documentElement.style.setProperty('--sticky-even', theme.palette.background.stickyEven);
  }, [mode]);
  return (
    <>
      {loading && <Loading open={loading} />}

      <Paper className={`${classes.root} mb-6`} elevation={3}>
        {/* 🔍 Search & Add Staff Header */}
        <Box display="flex" alignItems="center" justifyContent="space-between" mb={3}>
          <Box display="flex" alignItems="center">

            <TextField
              size="small"
              placeholder="Search now..."
              name="search"
              variant="outlined"
              onChange={handleSearchChange}
              onKeyPress={(e) => e.key === "Enter" && handleClickSearch()}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon
                      style={{
                        color: "#856f6f", // Icon color
                        cursor: "pointer",
                      }}
                      onClick={handleClickSearch}
                    />
                  </InputAdornment>
                ),
              }}
              className="modernSearchField"
            />
          </Box>

          {
            (
              (staffDetail === "Admin" || loggedRole === "ORGANIZATION") ||
              (
                loginUserInfo?.role !== "STAFF" ||
                loginUserInfo?.permissions?.some(
                  p => p?.toLowerCase() === "staff-create"
                )
              )
            ) && (
              <Button
                component={Link}
                to={`${match.url}/create`}
                variant="contained"
                color="primary"
                startIcon={<AddIcon />}
              >
                Add Staff
              </Button>
            )
          }

        </Box>

        {/* Staff Table */}
        <TableContainer className={classes.container}>
          <Table stickyHeader aria-label="sticky table">
            <EnhancedTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={(event, property) => {
                handleRequestSort(property, setOrder, setOrderBy, orderBy, order);
              }}
              rowCount={getStaffItem?.data?.data?.length}
              headCells={headCells[0]}
            />
            <TableBody>
              {getStaffItem?.data?.data?.filter(row => row?.deleted !== "0")?.map((row, index) => (
                <TableRow hover key={index}>
                  <TableCell style={{ color: theme.palette.listItem }}>{getStaffItem?.data?.from + index}</TableCell>
                  <TableCell>
                    <MuiLink
                      component={
                        (loginUserInfo?.role === "STAFF" &&
                          loginUserInfo?.permissions?.some((p) => p.toLowerCase() === "staff-view")) ||
                          loginUserInfo?.role !== "STAFF" ? RouterLink : "span"}
                      to="#"
                      onClick={(e) => {
                        if ((loginUserInfo?.role === "STAFF" &&
                          loginUserInfo?.permissions?.some((p) => p.toLowerCase() === "staff-view")) ||
                          loginUserInfo?.role !== "STAFF") {
                          e.preventDefault();
                          onhandlClick(row.id);
                        } else {
                          e.preventDefault();
                        }
                      }}
                      underline="hover"
                      sx={{
                        cursor: (loginUserInfo?.role === "STAFF" &&
                          loginUserInfo?.permissions?.some((p) => p.toLowerCase() === "staff-view")) || (loginUserInfo?.role !== "STAFF") ? "pointer" : "not-allowed",
                        color: "#3e81c3"

                      }}
                      className="clickableLink"
                    >
                      {`${row.first_name} ${row.last_name}`}
                    </MuiLink>
                  </TableCell>
                  <TableCell style={{ color: theme.palette.listItem }}>{row.email}</TableCell>
                  <TableCell style={{ color: theme.palette.listItem }}>{row.contact_number}</TableCell>
                  <TableCell style={{ color: theme.palette.listItem }}>{row.designation_name}</TableCell>
                  <TableCell style={{ color: theme.palette.listItem }}>{row?.role ?? "-"}</TableCell>
                  <TableCell align="center" style={{ color: theme.palette.listItem }}>
                    <Box style={{ display: "flex", gap: "4px" }}>
                      {getStaffItem?.is_smt === "Yes" && (
                        <Box
                          variant="outlined"
                          size="small"
                          style={{ cursor: "pointer" }}
                          color={row.deleted !== "0" ? "error" : "success"}
                          onClick={() =>
                            row.deleted !== "0"
                              ? onHandlDeActive(row.id)
                              : onHandlActive(row.id)
                          }
                        >
                          {row.deleted !== 0 ?
                            <Tooltip title="InActive"><ToggleOffIcon color="secondary" style={{ fontSize: "2.5rem" }} /></Tooltip>
                            : <Tooltip title="Active"><ToggleOnIcon style={{ fontSize: "2.5rem", color: "rgb(43 216 39)" }} /></Tooltip>}
                        </Box>
                      )}{" "}

                    </Box>
                  </TableCell>
                </TableRow>
              ))}

              {getStaffItem?.data?.data?.length === 0 && (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    Sorry, staff not available!
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination */}
        <TablePaginationControls
          page={page}
          rowsPerPage={perPage}
          totalRecords={getStaffItem?.data?.total}
          onPageChange={handleChangePage}
          handlePerPageChange={handlePerPageChange}
        />
      </Paper>


      <AlertDialog
        id={staffId}
        open={activeOpen}
        close={aActiveClose}
        response={alertActiveResponse}
        title="Active Staff Member"
        description="Are you sure you want to active this user?"
        buttonName="Active"
      />

      <AlertDialog
        id={staffId}
        open={deActiveOpen}
        close={dActiveClose}
        response={alertDeActiveResponse}
        title="Deactive Staff Member"
        description="Are you sure you want to deactive this user?"
        buttonName="Deactive"
      />
    </>
  );
};

export default ViewStaff;
